import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5325fbs04h: FaireBrandEntity = {
  token: "b_5325fbs04h",
  type: "brand",
  name: "Zoey Christina",
  avatarUrl:
    "https://cdn.faire.com/fastly/00ecb58472107cf3c7cb3f9c894786f40c5cd5913056d43c6ac55b5a258e200a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4b894bc8feff886fbe25969133b91b7551d4270e27b0e132da91ffbc81cf4b89.png",
  logoUrl:
    "https://cdn.faire.com/fastly/00ecb58472107cf3c7cb3f9c894786f40c5cd5913056d43c6ac55b5a258e200a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4b894bc8feff886fbe25969133b91b7551d4270e27b0e132da91ffbc81cf4b89.png",
  location: "Newaygo, MI, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 33,
  isTopShop: true,
  isInsider: true,
  description:
    "At the heart of Zoey Christina lies a story of family, creativity, and entrepreneurial spirit. I'm Sarah Kohlhoff, and this journey began with a deeply personal motivation - the desire to stay home with my daughter. Embracing the dual roles of motherhood and entrepreneurship, I founded Zoey Christina as more than just a business; it was my pathway to balance family life with professional passion.\n\nDriven by the dream of creating something meaningful while being present for my child's early years, I tapped into my creative roots. Zoey Christina, LLC was born out of a combination of necessity and inspiration. I set out to design unique, high-quality party supplies and gifts, channeling my artistic talent into a venture that allowed me the flexibility and joy of working from home.\n\nThis endeavor wasn't just about building a brand; it was about setting an example for my child that with determination and passion, you can shape a career that aligns with your personal values and life goals. Today, Zoey Christina stands as a testament to the power of a mother's love fused with entrepreneurial ambition.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:28.947Z",
    importedBy: "entity-db-cli",
  },
};
